import Repository from '@/repositories/repository'

const FundingAccountRepository = {
  async getAllFundingAccount(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '10',
      ...queryParams
    }

    return await Repository('funding-your-account', 'page', params)
  }
}

export default FundingAccountRepository
